import {Scrollbar} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react-lite';
import React, {useRef, useState} from 'react';

import {Column, Field, formsStore} from '../../../stores/Form';
import {getNextIndex} from '../utils';
import FormControl from './FormControl';
import styles from './styles.module.scss';

interface Props {
    columns: Column[];
}

const QuickCustomerForm = observer(({columns}: Props) => {
    const record = formsStore.currentForm.records[0];
    const inputRef = useRef([]);
    const [focusedInputIndex, setFocusedInputIndex] = useState(0);

    const focusNextInput = currentIndex => (name?: string, isBackword?: boolean) => {
        const nextIndex = name
            ? inputRef.current.findIndex(inpt => inpt.name === name)
            : getNextIndex(currentIndex, inputRef?.current, isBackword);

        inputRef.current[nextIndex]?.focus();
        setFocusedInputIndex(nextIndex);
    };

    return (
        <Scrollbar autoHeight autoHeightMax={550}>
            <div className={styles.form}>
                {columns.map((column, index) => {
                    const field: Field = record.getField(column.id);
                    return (
                        <FormControl
                            ref={el => (inputRef.current[index] = el)}
                            key={`${column.ID}`}
                            column={column}
                            field={field}
                            isFocused={focusedInputIndex === index}
                            focusNextInput={focusNextInput(index)}
                            isDisabled={column.isReadonly}
                        />
                    );
                })}
            </div>
        </Scrollbar>
    );
});

export default QuickCustomerForm;
